module.exports = __webpack_public_path__ + "static/media/UNKNOWN_WITH_KIDS.0e3c9787.svg";